import React from 'react';
import Paper from '@mui/material/Paper';
import '../App.css';
import SearchIcon from '@mui/icons-material/Search';
import { styled, alpha } from '@mui/material/styles';
import { Container } from '@mui/system';
import InputBase from '@mui/material/InputBase';

interface props {
    callback: (text: string) => void;
    text: string;
    id: string;
}

export const SearchBar: React.FC<props> = ({ callback, text, id }) => {

    const Search = styled('div')(({ theme }) => ({
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: alpha(theme.palette.common.white,0.8),
        '&:hover': {
            backgroundColor: alpha(theme.palette.common.white, 1),
        },
        marginLeft: 0,
        border: '1px solid #333333',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(1),
            justifyContent:"center",
        },
    }));

    const SearchIconWrapper = styled('div')(({ theme }) => ({
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }));

    const StyledInputBase = styled(InputBase)(({ theme }) => ({
        color: 'inherit',
        '& .MuiInputBase-input': {
            padding: theme.spacing(1, 1, 1, 0),
            // vertical padding + font size from searchIcon
            paddingLeft: `calc(1em + ${theme.spacing(4)})`,
            transition: theme.transitions.create('width'),
            width: '100%',
            [theme.breakpoints.up('sm')]: {
                width: '12ch',
                '&:focus': {
                    width: '20ch',
                },
            },
        },
    }));

    return (
        <Paper className='search-bar-panel' elevation={0} square={true}>
            <Container sx={{padding: '36px 0'}}>
                <Search>
                    <SearchIconWrapper>
                        <SearchIcon />
                    </SearchIconWrapper>
                    <StyledInputBase
                        autoFocus
                        placeholder="Cerca…"
                        inputProps={{ 'aria-label': 'search' }}
                        onChange={(e) => callback(e.target.value)}
                        value={text}
                        id={id}
                    />
                </Search>
            </Container>
        </Paper>
    );
}
